module.exports = __webpack_public_path__ + "static/media/map-egypt.4ef8afb0.png";